import type { FC } from 'react';
import { lazy } from 'react';

import { Outlet, useNavigate } from 'react-router';

import { useAppSelector } from '@/hooks/redux-hooks';
import { useGxTokenFromStorage, useTripTokenFromStorage } from '@/services/storage';
import { withSuspense } from '@/utils/withSuspense';

const ErrorPage = lazy(() => import('@/pages/ErrorPage'));

/**
 * Public layout for unauthenticated routes.
 *
 * - Allows access to public pages without authentication
 * - Handles auth failure states by redirecting to logout or showing 404
 * - Used for landing pages, login, registration, etc.
 */
export const PublicLayout: FC = () => {
  const { status } = useAppSelector(state => state.auth);
  const navigate = useNavigate();
  const gxToken = useGxTokenFromStorage();
  const tripToken = useTripTokenFromStorage();

  if (status === 'failed') {
    if (!!gxToken && !!tripToken) {
      navigate('/logout');
      return null;
    }
    return withSuspense(<ErrorPage />);
  }

  return <Outlet />;
};
